import { Grid } from "@mui/material";
import { useCallback } from "react";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { useStatsSlice } from "@/src-refactor/modules/store/redux/stats/stats.slice";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";

const PropertyDraftDeleteAllButton = () => {
  const { guardReadOnlyAction } = useReadOnlyModeGuard();

  const handleDeleteAll = useCallback(() => {
    guardReadOnlyAction("eliminar todos los borradores", "property-drafts-list");
  }, [guardReadOnlyAction]);

  const { stats } = useStatsSlice();
  if (!Boolean(stats?.countDrafts)) return null;
  return (
    <Grid item sm={"auto"}>
      <MxButton2
        textColor="white"
        children="Eliminar todos los borradores"
        onClick={handleDeleteAll}
        variant="contained"
        bgColor="error.main"
        testId="create-draft-button"
      />
    </Grid>
  );
};
export default PropertyDraftDeleteAllButton;
